const HomeCardInfo = 
        `Hola, My name is Andrés, I am graduate from the University of New Hampshire 
        Full Stack Coding Boot Camp. I have acquired skills in HTML, CSS, Javascript, 
        JQuery, Bootstrap, Node.js, Express, Express Handlebars, MySQL, sequelize, 
        MongoDB, Mongoose, Typescript and React. When I am not coding, I like to travel, 
        play video games, and watch movies. While you are here, take a look at my 
        awesome applications that I have created. If you would like to get to know me 
        more, please feel free to reach out to me.`


export default HomeCardInfo;